import { render } from "./travelRecords.vue?vue&type=template&id=6059d7e2&scoped=true"
import script from "./travelRecords.vue?vue&type=script&lang=js"
export * from "./travelRecords.vue?vue&type=script&lang=js"

import "./travelRecords.vue?vue&type=style&index=0&id=6059d7e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6059d7e2"]])

export default __exports__